import { PLAYER } from '../core/config';
import { clamp, damp } from '../core/math';
import type { ControlMode, InputFrame } from '../controls/types';

export interface VisitorCameraState {
  readonly yaw: number;
  readonly elevation: number;
  readonly distance: number;
}
export const INITIAL_VISITOR_CAMERA: VisitorCameraState = { yaw: 0, elevation: 0.2, distance: 4 };

export function updateVisitorCamera(
  state: VisitorCameraState,
  frame: InputFrame,
  mode: ControlMode,
  dt: number
): { state: VisitorCameraState; frame: InputFrame } {
  let yaw = state.yaw - (frame.orbitDx ?? 0) * PLAYER.lookRadPerPx;
  yaw = Math.atan2(Math.sin(yaw), Math.cos(yaw));
  const elevation = clamp(
    state.elevation + ((frame.orbitDy ?? 0) + frame.lookDy) * PLAYER.lookRadPerPx,
    -0.15,
    1.1
  );
  let lookDx = frame.lookDx;
  if (frame.mouseSteer) {
    lookDx -= yaw / PLAYER.lookRadPerPx;
    yaw = 0;
  } else if (!frame.mouseOrbit && (frame.forward !== 0 || frame.right !== 0 || frame.turn)) {
    yaw = damp(yaw, 0, 0.16, dt);
  }
  const zoom = mode === 'walk' || mode === 'boat';
  return {
    state: {
      yaw,
      elevation,
      distance: zoom ? clamp(state.distance - frame.wheelSteps * 0.5, 1.5, 8) : state.distance,
    },
    frame: {
      ...frame,
      lookDx,
      lookDy: mode === 'fly' ? frame.lookDy : 0,
      wheelSteps: zoom ? 0 : frame.wheelSteps,
    },
  };
}
